import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=71a074dc&scoped=true"
import script from "./Tech.vue?vue&type=script&lang=js"
export * from "./Tech.vue?vue&type=script&lang=js"
import style0 from "./Tech.vue?vue&type=style&index=0&id=71a074dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a074dc",
  null
  
)

export default component.exports